import validate from "/home/aquarist/www/pipeclub/node_modules/nuxt/dist/pages/runtime/validate.js";
import maintenance_45global from "/home/aquarist/www/pipeclub/middleware/maintenance.global.ts";
import manifest_45route_45rule from "/home/aquarist/www/pipeclub/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  maintenance_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}